import { environment } from '../../../../../environments/environment';
import { Component, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-consent-iframe',
  templateUrl: './consent-iframe.component.html',
  imports: [TranslateModule],
  host: {
    style: 'display: block; overflow: hidden;',
  },
})
export class ConsentIframeComponent {
  @ViewChild('iframe', { static: false }) iframe?: any;

  @Input() set key(key: string) {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`${environment.consentAppUrl}/consent/${key}`);
  }

  @Output() onDocumentsSigned = new EventEmitter<any>();

  iframeUrl?: SafeResourceUrl;
  token?: string;

  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly authService: AuthService,
  ) {
    this.setAuthToken();
  }

  @HostListener('window:message', ['$event'])
  onIframeMessage(event: MessageEvent): void {
    if (![environment.consentAppUrl, window.location.origin].includes(event.origin)) {
      return;
    }
    if (event.origin === window.location.origin && event.data.type === 'session-refresh') {
      this.setAuthToken();
      this.sendAuthTokenToIFrame(true);
      return;
    }
    switch (event.data.type) {
      case 'signed':
        this.onConsentSigned(event.data.documentIds);
        break;
      case 'ready':
        this.sendAuthTokenToIFrame();
        break;
    }
  }

  onConsentSigned(documentIds: string[]): void {
    this.onDocumentsSigned.emit(documentIds);
  }

  private sendAuthTokenToIFrame(isRefresh = false): void {
    if (!this.iframe) return;
    this.iframe.nativeElement.contentWindow.postMessage(
      {
        type: isRefresh ? 'refresh' : 'auth',
        token: this.token,
        timestamp: Date.now(),
      },
      environment.consentAppUrl,
    );
  }

  private async setAuthToken(): Promise<void> {
    this.token = await this.authService.getToken();
  }
}
